export const server = "https://pj-dealingreport-api-dev.agile168.com/";
export const days = 7;


// WEBPACK FOOTER //
// ./src/api/env.js